import React from "react";

function SliderContent({ activeIndex, dataTestimonials }) {
  return (
    <section>
      {dataTestimonials.map((slide, index) => (
        <div
          key={index}
          className={index === activeIndex ? "slides active" : "inactive"}
        >
          <div className="flex justify-center items-center p-6 space-x-2 flex-col md:flex-row ">
            <img
              src={slide.img}
              alt="captain"
              className="h-60 w-60 rounded-full mx-8 my-4"
            />
            <div className="w-3/4 md:w-1/2 mx-auto flex flex-col justify-center">
              <p>{slide.message}</p>
              <div className="mt-8">
                <h4 className="font-josefin text-mix-400 font-bold text-lg">{slide.name}</h4>
                <p className="text-gray-700 font-semibold">{slide.post}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default SliderContent;
